<template>
    <div dir="auto">
        <div class="row p-3">
            <label for="title">Title</label>

            <input
                id="title"
                v-model="post.title"
                type="text"
                class="form-control"
                :class="{
                    'is-invalid': hasError('title')
                }"
                dir="auto"
                @input="clearServerError('title')"
            />
            <div class="invalid-feedback">
                {{ getError('title') }}
            </div>
        </div>
        <div class="row p-3">
            <label for="title">Subtitle</label>

            <input
                id="subtitle"
                v-model="post.subtitle"
                type="text"
                class="form-control"
                :class="{
                    'is-invalid': hasError('subtitle')
                }"
                dir="auto"
                @input="clearServerError('subtitle')"
            />
            <div class="invalid-feedback">
                {{ getError('subtitle') }}
            </div>
        </div>

        <div class="row p-3">
            <label for="description">Description</label>

            <wysiwyg-editor
                id="description"
                v-model="post.description"
                :class="{ 'is-invalid': hasError('description') }"
                class="col-12 p-0"
                @input="clearServerError('description')"
            />

            <div class="invalid-feedback">
                {{ getError('description') }}
            </div>
        </div>

        <question
            v-for="(question, index) in post.content"
            :key="question.id"
            :question="question"
            :server-errors="serverErrors"
            :validation="validation.post.content.$each[index].answer"
            @input="onInput($event, question, index)"
        />
    </div>
</template>

<script>
import WysiwygEditor from '@/components/elements/WysiwygEditor';
import Question from '@/components/posts/Question';

export default {
    components: {
        WysiwygEditor,
        Question
    },

    props: {
        value: {
            type: Object,
            required: false,
            default: () => ({})
        },
        editMode: {
            type: Boolean,
            required: false,
            default: false
        },
        validation: {
            type: Object,
            required: true
        },
        serverErrors: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            post: {}
        };
    },

    watch: {
        post() {
            this.$emit('input', this.post);
        }
    },

    created() {
        const { boardId = null } = this.$route.params;

        this.post = {
            ...this.value,
            boardId: this.value.boardId || boardId
        };
    },

    methods: {
        onInput(answer, question, index) {
            this.post.content.splice(index, 1, { ...question, answer });

            this.clearServerError(question.label);
        },

        hasError(key) {
            return (
                this.validation?.post[key]?.$error ||
                this.serverErrors.find(error => error.param === key)
            );
        },

        getError(key) {
            return this.$getValidationErrorMessageHandler.handle(
                this.validation.post,
                this.serverErrors,
                key
            );
        },

        clearServerError(param) {
            this.$emit('clear-server-error', param);
        }
    }
};
</script>
